module.exports = "/_next/static/images/08ed806b5052adda19aa20aca24985f5-kaszek.png";